export const LOAN_CPID = 'e0747c';
export const CARD_CPID = 'e65b06';
